import { postCoachmarkRect } from "./postmessage";

// Selectors verified against the rendered preview DOM:
// - editable photo spots carry data-editable-type="image" (Photo.jsx)
// - the page-0 title renders as the only <h1> (Heading.H1)
const SELECTORS = {
  photo: '[data-editable-type="image"]',
  title: "h1"
};

// Computes the on-screen rect (CSS px, page viewport coords) of the
// coachmark target and reports it to the native app. Posts a null rect
// if the target is not present so the app can fall back gracefully.
export function measureCoachmarkTarget(target) {
  const selector = SELECTORS[target];
  if (!selector) return;

  const viewportWidth = window.innerWidth;

  const el = document.querySelector(selector);
  if (!el) {
    postCoachmarkRect(target, null, viewportWidth);
    return;
  }

  let r = el.getBoundingClientRect();

  // The title heading box spans the full column (e.g. 60vw, right-aligned),
  // so its element rect is far wider than the visible words. Measure the
  // actual text run instead so the spotlight hugs the title text.
  if (target === "title") {
    try {
      const range = document.createRange();
      range.selectNodeContents(el);
      const textRect = range.getBoundingClientRect();
      if (textRect && textRect.width > 0 && textRect.height > 0) {
        r = textRect;
      }
    } catch (e) {
      // fall back to the element rect
    }
  }

  postCoachmarkRect(
    target,
    {
      x: r.left,
      y: r.top,
      width: r.width,
      height: r.height
    },
    viewportWidth
  );
}
